import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ManageCRRAModel } from 'src/Models/ManageCRRAModel';

@Injectable({
  providedIn: 'root'
})
export class ManageCrraMasterService {

  AppUrl: string = "";
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.AppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  GetManageCRRADetails(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    let URL = this.AppUrl + 'api/ManageCRRA/GetManageCRRADetails';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(URL, httpOptions)
      .pipe(catchError(this.handleError));
  }

  SaveManageCRRADetails(TokenKey: string, postModel: ManageCRRAModel): Observable<any> {
    this.setAPIUrl();
    let URL = this.AppUrl + 'api/ManageCRRA/SaveManageCRRADetails';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(URL, postModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

}
